export enum StoryDateType {
  'Unknown' = 0,
  'ExactDate' = 1,
  'MonthAndYear' = 2,
  'Year' = 3,
}
